export enum LoginBackgroundType {
  AUTO = 'AUTO',
  COLOR = 'COLOR',
  IMAGE = 'IMAGE',
  LOTTIE = 'LOTTIE',
}
